<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      spinner-variant="primary"
      spinner-small
      rounded="sm"
    >
      <b-alert
        variant="danger"
        :show="alertErrors.length > 0"
        class="mb-0"
      >
        <div
          v-for="(row, index) in alertErrors"
          :key="index"
          class="alert-body"
        >
          <feather-icon

            icon="InfoIcon"
            class="mr-50"
          />
          {{ row }}
        </div>
      </b-alert>
      <b-card
        aria-hidden="true"
        class="mb-0"
        title="Personal Information"
      >
        <b-overlay
          id="overlay-background"
          :show="removeBtnLoader"
          variant="dark"
          opacity="0.85"
          blur="2px"
          spinner-variant="primary"
          spinner-small
          rounded="sm"
        >
          <div class="d-flex justify-content-end">
            <b-button
              v-if="$ability.can(constants.action.permissionPartnerDelete, constants.resource.partner)"
              variant="primary"
              class="mb-3"
              @click="confirmation(partnerData.id)"
            >
              <span class="text-nowrap">{{ $t('DEBTIA_REMOVE_PARTNER') }}</span>
            </b-button>
          </div>
        </b-overlay>
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >

          <!-- User Info: Input Fields -->
          <b-form
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <b-row>

              <!-- Field: Username -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  data-vv-validate-on="blur"
                  rules="required|alpha-num"
                >
                  <b-form-group

                    :label="$t('DEBTIA_USERNAME')"
                    label-for="username"
                  >
                    <b-form-input
                      id="username"
                      v-model="partnerData.username"
                      trim
                      :maxlength="maxCharactersAllowed"
                      @input="characterLeft"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <div>
                      <small
                        :style="maxCharacters > 10 ? 'color: green' : 'color: red'"
                      >
                        {{ maxCharacters }} characters left out of {{ maxCharactersAllowed }}
                      </small>
                    </div>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Full Name -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_NAME')"
                    label-for="full-name"
                  >
                    <b-form-input
                      id="full-name"
                      v-model="partnerData.name"
                      trim
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Email -->
              <b-col
                cols="12"
                md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="email"
                >
                  <b-form-group
                    :label="$t('DEBTIA_EMAIL')"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="partnerData.email"
                      trim
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: Phone -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_PHONE')"
                  label-for="phone"
                >
                  <b-form-input
                    id="phone"
                    v-model="partnerData.phone"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Status -->
              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_LOGIN')"
                  label-for="login-status"
                >
                  <v-select
                    v-model="partnerData.loginStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="loginOptions"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="login-status"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Contact Person -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_CONTACT_PERSON')"
                  label-for="contact-person"
                >
                  <b-form-input
                    id="contact-person"
                    v-model="partnerData.contact_person"
                    trim
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col
                cols="12"
                md="12"
              ><h4>{{ $t('DEBTIA_ADDRESS') }}</h4></b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_HOUSE_NUMBER')"
                  label-for="house-number"
                >
                  <b-form-input
                    id="house-number"
                    v-model="partnerData.address.house_no"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_ROAD_NAME')"
                  label-for="road-name"
                >
                  <b-form-input
                    id="road-name"
                    v-model="partnerData.address.road_name"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Place -->
              <b-col
                cols="12"
                md="4"
              >

                <b-form-group
                  :label="$t('DEBTIA_PLACE_NAME')"
                  label-for="place"
                >
                  <b-form-input
                    id="place"
                    v-model="partnerData.address.place"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Zipcode -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_ZIP_CODE')"
                  label-for="zip-code"
                >
                  <v-select
                    v-model="partnerData.address.zip_code"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="zipCodes"
                    :reduce="val => val.value"
                    :clearable="false"
                    @input="getCityId($event)"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: City -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_CITY')"
                  label-for="city"
                >
                  <v-select
                    v-model="partnerData.address.city_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="cities"
                    :reduce="val => val.value"
                    :clearable="false"
                    @input="getZipCode($event)"
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Country -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('DEBTIA_COUNTRY')"
                  label-for="country"
                >
                  <v-select
                    v-model="partnerData.address.country_id"
                    :disabled="busy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="countries"
                    :reduce="val => val.value"
                    :clearable="false"
                    input-id="select-country"
                    :value="'Select Country'"
                  >
                    <template
                      #selected-option-container="{ option }"
                    >
                      <div class="vs__selected">
                        {{ $t(option.label) }}</div>
                    </template>
                    <template
                      slot="option"
                      slot-scope="option"
                    >
                      {{ $t(option.label) }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

            </b-row>
            <hr>

            <!-- Action Buttons -->
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
            >
              Save Changes
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              Reset
            </b-button>
          </b-form>

        </validation-observer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BFormGroup, BFormInput, BForm, BCard, BAlert, BOverlay,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import axios from '@axios'
// import Cleave from 'vue-cleave-component'
// import i18n from '@/libs/i18n'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import countries from '@/countries'
import constants from '@/app-configs/constants'

import { required, alphaNum, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BCard,
    vSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BAlert,
    BOverlay,
  },
  props: {
  },
  data() {
    return {
      loader: false,
      constants,
      loginOptions: [
        { label: 'Allowed', value: '1' },
        { label: 'Not Allowed', value: '0' },
      ],
      busy: false,
      countries,
      required,
      alphaNum,
      email,
      alertErrors: [],
      partnerData: {
        username: '',
        name: '',
        email: '',
        phone: '',
        password: '',
        loginStatus: 1,
        contact_person: '',
        address: {
          house_no: null,
          road_name: null,
          place: null,
          zip_code: null,
          city_id: null,
          country_id: null,
        },
      },
      debtCaseId: 0,
      options: {
        cprDelimiter: {
          delimiters: ['-'],
          blocks: [6, 4],
          uppercase: true,
        },
      },
      termSheetCodeOptions: [],
      termSheetCodeLoader: false,
      maxCharacters: 50,
      maxCharactersAllowed: 50,
      zipCodes: [],
      cities: [],
      removeBtnLoader: false,
      // collectiontypeoptions: [
      //   { text: i18n.t('DEBTIA_FOREIGN'), value: 'foreign' },
      //   { text: i18n.t('DEBTIA_OWN'), value: 'own' },
      // ],
    }
  },
  computed: {
  },
  created() {
    this.getPartnerDetails()
    this.getCitiesDropdown()
    this.getZipCodesDropdown()
    this.debtCaseId = this.$route.query.debt_case_id
    this.maxCharacters = this.maxCharactersAllowed - 10
  },
  methods: {
    async confirmation(id) {
      // methodId
      this.$swal({
        title: 'Caution',
        html: 'Are you sure to delete this partner?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.secondConfirmation(id)
        }
      })
    },
    async secondConfirmation(id) {
      try {
        this.loader = true
        const casesresponse = await axios.get(`/partners/debt-cases/${id}`)
        // this.loader = false
        if (casesresponse.status) {
          this.loader = false
          const noOfCases = casesresponse.data.data.length
          const cases = casesresponse.data.data
          let msg = 'Are you sure to delete this partner?'
          if (noOfCases > 0) {
            msg = 'Partner is assigned to the following case(s) '
            cases.forEach((element, index) => {
              if (index !== 0) {
                msg += ', '
              }
              msg += element
            })
            msg += '<p>Are you sure to delete this partner?</p>'
            // methodId
            this.$swal({
              title: 'Caution',
              html: msg,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                this.deletePartner(id)
              }
            })
          } else {
            this.deletePartner(id)
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: 'Partner could not be deleted.',
          },
        })
      }
    },
    async deletePartner(id) {
      try {
        this.loader = true
        const obj = {
          id,
        }
        const partner = await axios.post('/partners/delete', obj)
        // this.loader = false
        if (partner.status) {
          this.loader = false
          this.$router.push({ name: 'partner-list' })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: 'Partner could not be deleted.',
          },
        })
      }
    },
    async getZipCodesDropdown() {
      await axios.get('settings/zip-codes/dropdown?country=Danmark')
        .then(response => {
          this.zipCodes = response.data.data
        }).catch(() => false)
    },
    async getCitiesDropdown() {
      await axios.get('settings/get-cities-dropdown?country=Danmark')
        .then(response => {
          this.cities = response.data.data
        }).catch(error => {
          console.log(error)
        })
    },
    async getPartnerDetails() {
      this.loader = true
      const partnerID = this.$route.params.id
      await axios.get(`/partners/${partnerID}`)
        .then(response => {
          this.loader = false
          this.partnerData = response.data.data
          this.duplicatePartnerData = response.data.data
        })
        .catch(error => {
          console.log('error is ', error)
        })
    },
    async getCityId(event) {
      await axios.get(`settings/get-city-id-by-zip-code?code=${event}`)
        .then(response => {
          if (response.data.data.city_name !== null) {
            this.partnerData.address.city_id = response.data.data.city_id
          }
        }).catch(error => {
          console.log(error)
        })
    },
    async getZipCode(event) {
      await axios.get(`settings/get-zip-code-by-city-id?city_id=${event}`)
        .then(response => {
          if (response.data.data.zip_code !== null) {
            this.partnerData.address.zip_code = response.data.data.zip_code
          }
        }).catch(error => {
          console.log(error)
        })
    },
    onSubmit() {
      this.loader = true
      const obj = {
        id: this.partnerData.id,
        name: this.partnerData.name,
        username: this.partnerData.username,
        contact_person: this.partnerData.contact_person,
        email: this.partnerData.email,
        phone: this.partnerData.phone,
        address: {
          road_name: this.partnerData.address.road_name,
          house_number: this.partnerData.address.house_no,
          place: this.partnerData.address.place,
          zip_code: this.partnerData.address.zip_code,
          city_id: this.partnerData.address.city_id,
          country_id: this.partnerData.address.country_id,
        },
        loginStatus: this.partnerData.loginStatus,
      }
      axios
        .post('/partners/edit', { ...obj })
        .then(response => {
          if (response.status) {
            this.loader = false
            this.showComponentToast('Success', 'success', 'Partner has been updated successfully.')
            this.$router.push('/partner/list')
          }
        })

        .catch(error => {
          this.loader = false
          this.showComponentToast('Failed', 'danger', error.response.data.message[0])
        })
    },
    showComponentToast(title, variant, msg) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon: 'TwitchIcon',
          variant,
          text: msg,
        },
      })
    },

    resetForm() {
      this.getPartnerDetails()
    },
    characterLeft(event) {
      this.maxCharacters = this.maxCharactersAllowed - event.length
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}

.custom-control.custom-control-inline.custom-radio {
  margin-top: 5px;
}
</style>
